"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkListItem = exports.LinkList = void 0;
const react_1 = __importDefault(require("react"));
const outline_1 = require("@heroicons/react/outline");
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_icon_1 = __importDefault(require("@hydrogen/elements.ui.icon"));
const elements_ui_configs_1 = require("@hydrogen/elements.ui.configs");
const AsButton = (props) => (react_1.default.createElement("button", { type: "button", onClick: props.onClick, className: "w-full transition block  hover:bg-misc-50" }, props.children));
const AsLink = (props) => {
    const Link = (0, elements_ui_configs_1.getLink)();
    const className = 'transition block  hover:bg-misc-50';
    if (props.external) {
        return (react_1.default.createElement("a", { href: props.to, target: "_blank", rel: "noreferrer", className: className, onClick: props.onClick }, props.children));
    }
    if (!props.to) {
        return (react_1.default.createElement("div", null, props.children));
    }
    return (react_1.default.createElement(Link, { to: props.to, className: className, onClick: props.onClick, state: props.state }, props.children));
};
const LinkItemIcon = ({ external, LinkIcon, href, show = false, }) => {
    const externalIcon = external ? outline_1.ExternalLinkIcon : outline_1.ChevronRightIcon;
    if (!href && !show)
        return null;
    if (LinkIcon) {
        return (react_1.default.createElement(LinkIcon, { className: "h-5 w-5 text-secondary-500 rtl:rotate-180", "aria-hidden": "true" }));
    }
    return (react_1.default.createElement(elements_ui_icon_1.default, { icon: externalIcon, className: "text-secondary-500 rtl:rotate-180" }));
};
const tags = {
    button: AsButton,
    link: AsLink,
};
function LinkListItem(props) {
    const baseClasses = 'flex items-center gap-4 text-start';
    const variantClasses = {
        default: 'p-4 sm:px-6',
        compact: 'p-4',
    };
    const variant = props.variant || 'default';
    const Tag = (typeof props.as === 'string' && tags[props.as]) || props.as || tags.link;
    return (react_1.default.createElement("li", { className: (0, elements_ui_utils_1.classNames)('border-0', props.className) },
        props.prefix || null,
        react_1.default.createElement(Tag, { to: props.to, onClick: props.onClick, external: props.external, state: props.state },
            react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(baseClasses, variantClasses[variant]) },
                react_1.default.createElement("div", { className: "min-w-0 flex-1 flex items-start" }, props.children),
                (props.to || props.showIcon) && (react_1.default.createElement("div", { className: "block" },
                    react_1.default.createElement(LinkItemIcon, { external: props.external, LinkIcon: props.icon, href: props.to, show: props.showIcon })))))));
}
exports.LinkListItem = LinkListItem;
function LinkList(props) {
    var _a;
    return (react_1.default.createElement("ul", { className: "divide-y divide-misc-200" }, (_a = props.children) !== null && _a !== void 0 ? _a : null));
}
exports.LinkList = LinkList;
//# sourceMappingURL=link-list.js.map